import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { TRANSFER_BUILDING } from './url-constants';

type TransferBuildingEndpointSpecifications = ApiEndpointSpecification;
export const TransferBuildingEndpointSpecification: TransferBuildingEndpointSpecifications = {
    url: TRANSFER_BUILDING,
    method: HttpMethod.POST,
    requestParamsSchemaName: 'BuildingTransferRequestParams',
    requestBodySchemaName: 'BuildingTransferRequestBody',
    okResponseSchemaName: 'BuildingTransferRequestOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokeTransferBuildingRequest = Helpers.makeApiRequestFn<
    Types.TransferBuildingRequestParams,
    Types.TransferBuildingRequestBody,
    Types.TransferBuildingRequestOkResponse
>(TransferBuildingEndpointSpecification);
